import { render } from "./LbrxReservePopup.vue?vue&type=template&id=517a145d&scoped=true"
import script from "./LbrxReservePopup.vue?vue&type=script&lang=js"
export * from "./LbrxReservePopup.vue?vue&type=script&lang=js"

import "./LbrxReservePopup.vue?vue&type=style&index=0&id=517a145d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517a145d"]])

export default __exports__